import { useEffect, useCallback } from 'react';
import { ModalCloseEvent } from '@johnlewispartnership/wtr-ingredients/ingredients/Modal/Modal.js';
import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';

const modalName = 'multi-search-list';
const modalAction = 'Manage Multi Search List';
const modalId = 'multi-search-list';
const modalTitle = 'Multi-search';

export const useModalGAEvents = ({ isOpen }: { isOpen: boolean }) => {
  const { trackEvent } = useAnalytics();
  const openModal = useCallback(() => {
    trackEvent({
      event: 'open_modal',
      modal_name: modalName,
      action: modalAction,
      id: modalId,
      title: modalTitle,
    });
  }, [trackEvent]);

  const clickInteraction = useCallback(
    ({ action }: { action: 'Clear list' }) => {
      trackEvent({
        event: 'click_interaction',
        classification: action,
        action: 'click',
      });
    },
    [trackEvent],
  );

  const closeModal = useCallback(
    ({ action, event }: { action: 'close' | 'Search'; event?: ModalCloseEvent }) => {
      let alternativeLabel = '';

      if (action === 'close' && event && event.domEvent) {
        const { target } = event.domEvent;
        alternativeLabel = ['svg', 'path'].includes((target as HTMLElement)?.tagName)
          ? 'X'
          : 'outside_click';
      }

      trackEvent({
        event: 'close_modal',
        modal_name: modalName,
        action: modalAction,
        id: modalId,
        title: modalTitle,
        user_action: alternativeLabel || action,
      });
    },
    [trackEvent],
  );

  useEffect(() => {
    if (isOpen) openModal();
  }, [isOpen, openModal]);

  return {
    clickInteraction,
    closeModal,
  };
};
